import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { settingsPageStyles } from "component/shared/settings-page";

export const styles = (theme: Theme) => {
	const shared = settingsPageStyles(theme);
	return ({
		labelTitle: shared.labelTitle,
		labelDescription: {
			...shared.labelDescription,
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(2),
		},
		divider: {
			margin: theme.spacing(3, 0),
		},
	} satisfies Record<string, CSSObject>);
};
